import Vue from "vue";
import Icon from "@/components/Elements/Icon";
import Btn from "@/components/Elements/Btn";
import Page from "@/components/Elements/Page";
import Section from "@/components/Elements/Section";
import Alert from "@/components/Elements/Alert";
import PolmedSpinner from "@/components/Elements/Spinner";
import Loading from "@/components/Elements/Loading";
import "@/filters/truncate.ts";
import "@/filters/currency.ts";
import "@/filters/percent.ts";

// import BootstrapVue from "bootstrap-vue";
// import { i18n, loadLanguageFromChunk } from "@/i18n/";

// import "@/styles/_bootstrap.scss";
// import "@/styles/main.scss";

Vue.config.productionTip = false;

// require("@/filters/truncate.js");

// Vue.use(BootstrapVue);
// Vue.use(require("vue-moment"));

Vue.component("PolmedSpinner", PolmedSpinner);
Vue.component("Loading", Loading);
Vue.component("Alert", Alert);
Vue.component("Page", Page);
Vue.component("Section", Section);
Vue.component("Icon", Icon);
Vue.component("Btn", Btn);

// loadLanguageFromChunk(i18n.locale, "default");
// loadLanguageFromChunk(i18n.locale, "validation");
// loadLanguageFromChunk(i18n.locale, "certification-form");
// loadLanguageFromChunk(i18n.locale, "event");

// export { i18n };
